var ReadType;
(function (ReadType) {
    ReadType[ReadType["unread"] = 0] = "unread";
    ReadType[ReadType["read"] = 1] = "read";
    ReadType[ReadType["loading"] = 11] = "loading";
    ReadType[ReadType["loading2"] = 12] = "loading2";
    ReadType[ReadType["warning"] = 13] = "warning";
})(ReadType || (ReadType = {}));
export default ReadType;

//# sourceMappingURL=read-type.js.map
